/* @flow weak */
import _ from 'lodash';

const STRIPE_JS = 'https://js.stripe.com/v3/';

let loadId = null;

export default class StripeAPI {
  static load() {
    if (window.Stripe) {
      return Promise.resolve(window.Stripe);
    }

    const $script = require('scriptjs');

    if (!loadId) {
      $script(STRIPE_JS, (loadId = _.uniqueId('stripe')));
    }

    return new Promise(resolve => {
      $script.ready(loadId, () => {
        resolve(window.Stripe);
      });
    });
  }
}
